// extracted by mini-css-extract-plugin
export default {"suggestions":"Suggestions_suggestions__Lg32m","suggestion":"Suggestions_suggestion__IHqqE"};